<p-toolbar>
    <ng-template #start>
        <div>
            <label class="pr-2 nobr lbl">Дата с</label>
            <p-datepicker [(ngModel)]="fd" name="fd" dateFormat="dd.mm.yy" [showTime]="true" showIcon iconDisplay="input" hourFormat="24" />
        </div>

        <div>
            <label class="pl-2 pr-2 nobr lbl">Дата по</label>
            <p-datepicker [(ngModel)]="td" name="td" dateFormat="dd.mm.yy" [showTime]="true" showIcon iconDisplay="input" hourFormat="24" />
        </div>
    </ng-template>
    <ng-template #center>
        <div>
            <label class="pl-2 pr-2 lbl">Склад</label>
            <p-select 
                id="store" 
                [options]="storages" 
                [(ngModel)]="storeId" 
                optionLabel="name" 
                optionValue="id"  
                (ngModelChange)="storageSelected()">
            </p-select>
        </div>
    </ng-template>
    <ng-template #end>
        <div>
            <p-splitbutton (onClick)="sendBtnClickFn()" label="Отправить все треки" [model]="shipmentItems" />
        </div>
    </ng-template>
</p-toolbar>

<div class="p-4">
    <p-table [value]="shipmentsData | async | filter:'store_id':storeId" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th>#</th>
                <th class="nobr">Начальная дата</th>
                <th class="nobr">Конечная дата</th>
                <th>Склад</th>
                @if(cargoFeatures?.isDestStorage){
                <th class="nobr">Склад назначения</th>
                }
                <th class="nobr">Кол-во треков</th>
                <th>&nbsp;</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-shipment>
            <tr>
                <td>{{shipment.id}}</td>
                <td>{{shipment.fd | date:'dd.MM.yyyy HH:mm'}}</td>
                <td>{{shipment.td | date:'dd.MM.yyyy HH:mm'}}</td>
                <td>{{shipment.store_name}}</td>
                @if(cargoFeatures?.isDestStorage){
                <td>{{shipment.dest_storage_name ? shipment.dest_storage_name : "не указан" }} </td>
                }
                <td>{{shipment.tracks_count}}</td>
                <td>
                    <p-button pRipple (click)="shipmentData(shipment)" icon="pi pi-download" [rounded]="true"
                        [text]="true" severity="info" pTooltip="скачать CSV файл">
                    </p-button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-dialog header="Выбор города для отправки" [(visible)]="showCitySelectDialog" [modal]="true" [maximizable]="true"
    (onHide)="cancelTrackSelect()">
    <div class="p-fluid">
        @if(shipmentStoragies) {
        <div class="field">
            <p-select [options]="shipmentStoragies" [(ngModel)]="selectedCity" optionLabel="name" [showClear]="true"
                placeholder="Select a City" appendTo="body" id="cityToSend" optionValue="id">
            </p-select>
        </div>
        } @else {
        <div [ngStyle]="{'text-align': 'center'}">
            <p-progressSpinner styleClass="w-16 h-16" strokeWidth="6" fill="var(--surface-ground)"
                animationDuration="4s"></p-progressSpinner>
        </div>
        }
        <button pButton label="Создать отправление" (click)="makeShipmentByCity()"></button>
    </div>
</p-dialog>

<p-dialog header="Выбор треков для отправки" [(visible)]="showTrackSelectDialog" [modal]="true" [maximizable]="true"
    (onHide)="cancelTrackSelect()">

    <div style="width: 100%; height: 250px; overflow: auto" *ngIf="!dataLoadingState()">
        <table class="infoTable">
            <thead>
                <tr>
                    <th>&nbsp;</th>
                    <th>Трек-номер</th>
                    <th>Дата</th>
                    <th>Клиент</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let track of tracks4Shipment">
                    <td>
                        <p-checkbox [value]="track.id" [(ngModel)]="selectedTracks"></p-checkbox>
                    </td>
                    <td>{{track.tracknum}}</td>
                    <td>{{track.dt | date:'dd.MM.yyyy HH:mm'}}</td>
                    <td>{{track.client_code}}</td>
                </tr>
            </tbody>
        </table>
        <p-scrollTop target="parent" styleClass="custom-scrolltop" [threshold]="100"
            icon="pi pi-arrow-up"></p-scrollTop>
    </div>

    <div [ngStyle]="{'text-align': 'center'}">
        <p-progressSpinner *ngIf="dataLoadingState()" styleClass="w-16 h-16" strokeWidth="6"
            fill="var(--surface-ground)" animationDuration="4s"></p-progressSpinner>
    </div>

    <p-footer>
        <button pButton class="" label="Отправить треки" (click)="shipSelectedTracks()"
            [disabled]="dataLoadingState()"></button>
        <button pButton class="p-button-secondary" label="Отменить" (click)="cancelTrackSelect()"
            [disabled]="dataLoadingState()"></button>
    </p-footer>
</p-dialog>